import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import {
  AdSupplierGroup,
  CreateAdSupplierGroup,
  UpdateAdSupplierGroup,
} from '@magnetar/admin-api-interfaces'

export const adSupplierGroupService = {
  createAdSupplierGroup: async (data: CreateAdSupplierGroup, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean; data: AdSupplierGroup }>(
        '/api/ad-supplier-groups',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateAdSupplierGroup: async (groupId: number, data: UpdateAdSupplierGroup, token: string) => {
    try {
      const response = await apiClient.put<{ success: boolean; data: AdSupplierGroup }>(
        `/api/ad-supplier-groups/${groupId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  deleteAdSupplierGroup: async (groupId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/ad-supplier-groups/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // Supplier assignment
  assignSupplier: async (groupId: number, supplierId: number, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean }>(
        `/api/ad-supplier-groups/${groupId}/suppliers/${supplierId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  removeSupplier: async (groupId: number, supplierId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/ad-supplier-groups/${groupId}/suppliers/${supplierId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // Get available suppliers for assignment
  getAvailableSuppliers: async (
    groupId: number,
    params: { search?: string; page?: number; pageSize?: number },
    token: string,
  ) => {
    try {
      const response = await apiClient.get<{
        success: boolean
        data: {
          adSuppliers: Array<{
            supplier_id: number
            supplier_name: string
            manager: string
            phone: string
          }>
          total: number
          page: number
          pageSize: number
        }
      }>(`/api/ad-supplier-groups/${groupId}/available-suppliers`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        data: { adSuppliers: [], total: 0, page: 1, pageSize: 20 },
      }
    }
  },
}
